"use client";

import { zodResolver } from "@hookform/resolvers/zod";
import { useCallback, useEffect } from "react";
import { useForm } from "react-hook-form";
import z from "zod";
import { useAddDiscount } from "@/features/cart/hooks/use-add-discount";
import { useCartStoreService } from "@/features/cart/hooks/use-cart-store-service";
import type { CartStoreType } from "@/features/cart/types/cart-store-type";

const discountCodeSchema = z.object({
  discount: z.string().min(1),
});

export const useDiscountCode = (type?: CartStoreType) => {
  const { cartStore } = useCartStoreService({ type });
  const {
    addDiscount,
    handleRemove,
    isError,
    info,
    isRemoveLoading,
    isPending,
    errorDetails,
  } = useAddDiscount(type);

  const form = useForm({
    resolver: zodResolver(discountCodeSchema),
    defaultValues: {
      discount: "",
    },
  });

  const discount = form.watch("discount");

  useEffect(() => {
    if (!cartStore.discountCode) {
      form.setValue("discount", "");
    }
  }, [cartStore.discountCode, form]);

  const handleSubmit = useCallback(async () => {
    await addDiscount(discount, "koszyk_recznie");
  }, [addDiscount, discount]);

  return {
    handleRemove,
    handleSubmit,
    isError,
    info,
    discount,
    form,
    isRemoveLoading,
    isPending,
    errorDetails,
  };
};
